import { PrimaryButton } from '@changegps/horizon-component-library';
import { Box, Grid, Paper, Stack, Typography } from '@mui/material';

import Signature from '@/assets/img/default_signature.png';
import { ControlledInputs } from '@/components';

import { useGlobalLetterData, useGlobalLetterFormContext } from '../hooks';

interface ClosingProps {
  handleSave: () => void;
  isPending: boolean;
}

export const Closing = ({ handleSave, isPending }: ClosingProps) => {
  const form = useGlobalLetterFormContext();
  const letterData = useGlobalLetterData();

  return (
    <Box sx={{ padding: '24px' }}>
      <Grid container spacing={4}>
        {/* Left Side - Inputs */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Closing Statement
          </Typography>
          <ControlledInputs.TextEditor
            ControllerProps={{ control: form.control, name: `closing` }}
            modules={{
              toolbar: [
                ['bold', 'italic'],
                [{ list: 'ordered' }, { list: 'bullet' }],
              ],
            }}
            style={{ maxWidth: '100%' }}
          />

          {/* Signature Image Upload */}
          <Box sx={{ marginY: 3, textAlign: 'center' }}>
            <img
              src={Signature}
              alt="Signature"
              style={{ maxWidth: '150px', maxHeight: '80px' }}
            />
          </Box>

          <Typography variant="subtitle1" fontWeight="bold">
            Signature Text
          </Typography>
          <ControlledInputs.TextEditor
            ControllerProps={{ control: form.control, name: `signature` }}
            modules={{
              toolbar: [
                ['bold', 'italic'],
                [{ list: 'ordered' }, { list: 'bullet' }],
              ],
            }}
            style={{ maxWidth: '100%' }}
          />
        </Grid>

        {/* Right Side - Preview */}
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            Closing Statement Preview
          </Typography>
          <Paper
            sx={{ padding: 3, backgroundColor: '#f9f9f9', borderRadius: '8px' }}
            elevation={1}
          >
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{ __html: letterData.closing }}
            />

            <Stack direction="column" spacing={1}>
              <img
                src={Signature}
                alt="Signature"
                style={{ maxWidth: '150px', maxHeight: '80px' }}
              />
            </Stack>
            <Typography variant="body2" fontWeight="bold">
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    letterData.signature
                      ?.replace(
                        '{{sign_name}}',
                        `${letterData['signature-preview'].sign_name}`,
                      )
                      .replace(
                        '{{sign_qualifications}}',
                        letterData['signature-preview'].sign_qualifications,
                      )
                      .replace(
                        '{{sign_role}}',
                        letterData['signature-preview'].sign_role,
                      )
                      .replace(
                        '{{firm_name}}',
                        letterData['signature-preview'].firm_name,
                      ) ?? '',
                }}
              />
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Save Button */}
      <Box
        sx={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '16px' }}
      >
        <PrimaryButton onClick={handleSave} disabled={isPending}>
          Save Changes
        </PrimaryButton>
      </Box>
    </Box>
  );
};
